import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'
import Toast from '@common/components/Toast'
import { downloadUserAuditReportUsersAuditReportDownloadPost } from '@common/config/api/client'
import type { AxiosResponse } from 'axios'

const getFileNameFromContentDisposition = (contentDisposition: string | undefined, userId: string) => {
  if (!contentDisposition) {
    return `user_${userId}_audit_report.csv`
  }
  const match = contentDisposition.match(/filename="?([^"]+)"?/)
  return match ? match[1] : `user_${userId}_audit_report.csv`
}

export const useDownloadUserAuditReport = () =>
  useMutation({
    mutationFn: async (userId: string) => {
      const response = (await downloadUserAuditReportUsersAuditReportDownloadPost({
        responseType: 'blob',
      })) as AxiosResponse<Blob>

      const blob = response.data
      const url = window.URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = url

      const contentDisposition = response.headers?.['content-disposition']
      const fileName = getFileNameFromContentDisposition(contentDisposition, userId)

      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)

      return blob
    },
    onError: () => {
      toast(<Toast message="Failed to download audit report" variant="error" />)
    },
    onSuccess: () => {
      toast(<Toast message="Audit report downloaded successfully" variant="success" />)
    },
  })

export default useDownloadUserAuditReport
